import {Action} from '@ngrx/store';

export class LogoutSuccessAction implements Action {
  public static readonly type = 'LogoutSuccessAction';

  public type = LogoutSuccessAction.type;
}
